import { deadOps, discardDead, retryDead } from '../lib/queue';

/** Dead-letter review: every permanently-rejected change, visible and actionable —
 *  the §7 answer to v1's silent poison-drop. */
export function AttentionSheet({ onClose }: { onClose: () => void }) {
  const items = deadOps.value;
  return (
    <div class="overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div
        class="sheet max-h-[80dvh] overflow-y-auto"
        role="dialog"
        aria-modal="true"
        aria-label="Changes needing attention"
      >
        <h2 class="text-lg font-extrabold text-navy-900">Needs attention</h2>
        <p class="mt-1 text-sm text-slate-500">
          These changes were rejected by the server and are parked here — nothing is lost until you
          discard it.
        </p>
        {items.length === 0 && <p class="mt-4 text-sm text-slate-500">All clear.</p>}
        <ul class="mt-3 space-y-2">
          {items.map((op) => (
            <li
              key={op.opId}
              class="rounded-xl border border-red-100 bg-missed-tint p-3"
              data-testid="dead-item"
            >
              <p class="text-sm font-semibold text-navy-900">{op.label}</p>
              <p class="mt-0.5 text-xs text-missed-ink">
                {op.reason} ·{' '}
                {new Date(op.failedAt).toLocaleString([], {
                  dateStyle: 'short',
                  timeStyle: 'short',
                })}
              </p>
              <div class="mt-2 flex gap-2">
                <button
                  class="btn-ghost flex-1 !py-1.5 text-sm"
                  onClick={() => void retryDead(op.opId)}
                >
                  Retry
                </button>
                <button
                  class="btn-danger-outline flex-1 !py-1.5 text-sm"
                  onClick={() => {
                    if (confirm('Discard this change for good?')) void discardDead(op.opId);
                  }}
                >
                  Discard
                </button>
              </div>
            </li>
          ))}
        </ul>
        <button class="btn-primary mt-4 w-full" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
